import { render, staticRenderFns } from "./DashboardProtocolList.vue?vue&type=template&id=18c6d10e&"
import script from "./DashboardProtocolList.vue?vue&type=script&lang=js&"
export * from "./DashboardProtocolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports